import React, { useState, useEffect, useCallback } from 'react';
import { MdAdd } from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componentes
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function User() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDados = useCallback(async () => {
    setLoading(true);
    const response = await api.get(`/user`);
    const data = response.data.map(i => {
      let profision;
      switch (i.provider) {
        case '1':
          profision = 'Gerente';
          break;
        case '2':
          profision = 'Diretor';
          break;
        case '3':
          profision = 'Normal';
          break;
        default:
          profision = 'Bamboo';
      }
      return {
        ...i,
        profision,
        statusFormat: i.status === '1' ? 'Ativo' : 'Inativo',
      };
    });
    setDados(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    getDados();

    return function cleanup() {
      abortController.abort();
    };
  }, [getDados]);

  /**
   * Funções
   */

  async function handlerEditar(number) {
    history.push(`/user-edit/${number}`);
  }

  async function handlerStatus(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(`/user/${num}`);
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success(`Usuário ativado/desativado com sucesso`);
            getDados();
          }
        });
      } else {
        const response = await api.delete(`/user/${number}`);

        if (response.data) {
          toast.success(`Usuário ativado/desativado com sucesso`);
          getDados();
        }
      }
    } catch (error) {
      toast.error(`Erro ao ativar/desativar usuário`);
      getDados();
    } finally {
      setLoading(false);
    }
  }

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'email',
      label: 'E-mail',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'time.name',
      label: 'Time',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'profision',
      label: 'Cargo',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'statusFormat',
      label: 'Status',
      options: {
        filter: true,
        sort: false,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Usuário</h4>
      <Card>
        <Menus>
          <NewButton to="/user-create">
            <MdAdd size={16} color="#FFF" />
            Novo
          </NewButton>
        </Menus>
        <Table
          title="Integrações"
          data={dados}
          columns={columns}
          ds={handlerStatus}
          ed={handlerEditar}
          messages="Você deseja ativar/desativar o usuário ?"
          st
        />
      </Card>
    </Container>
  );
}
